export default "https://cdn-static.gokick.com/assets/7e5886a8604a8a782ca6a0de4eecb197b7d69c39/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";